import { Flex } from "antd";
import PropTypes from "prop-types";

const FullCenterBox = ({ children }) => (
  <Flex align="center" justify="center">
    {children}
  </Flex>
);

FullCenterBox.propTypes = {
  children: PropTypes.node,
};

export default FullCenterBox;
